module.exports = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  // BASE_URL: 'https://ilovet.herokuapp.com/v1/',
  // BASE_URL: 'https://api.ilovet.girasolo.mx/v1/',
  DEFAULT_PAGE_SIZE: 9,
  AVISO_PRIVACIDAD: '',
  ENVIRONMENT: 'PRODUCTION', // ['PRODUCTION', 'DEV']
};
